import { useQuery } from '@tanstack/react-query';

import { couponUsageApi } from '../lib/coupon-usage-api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Marketing
 * @graph-business クーポン利用状況サマリを取得するReact Queryフック。
 * @graph-connects couponUsageApi [calls] API呼び出し
 */
export function useCouponUsageSummary() {
  return useQuery({
    queryKey: queryKeys.couponUsage.summary,
    queryFn: () => couponUsageApi.getSummary(),
    staleTime: 5 * 60_000,
    retry: false,
  });
}

/**
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Marketing
 * @graph-business 特定クーポンの利用ユーザー一覧を取得するReact Queryフック。
 * @graph-connects couponUsageApi [calls] API呼び出し
 */
export function useCouponUsageUsers(couponMasterId: string | null) {
  const id = couponMasterId ?? '';
  return useQuery({
    queryKey: queryKeys.couponUsage.users(id),
    queryFn: () => couponUsageApi.getUsers(id),
    enabled: couponMasterId !== null,
    staleTime: 5 * 60_000,
    retry: false,
  });
}
